export { default as SvgIcon } from './svg-icon';
export type { SvgIconProps } from './types';
